var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_258_585)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9554 0.797422C26.1547 1.12032 27.1004 2.06595 27.4233 3.26529C28.0229 5.45638 27.9999 10.0231 27.9999 10.0231C27.9999 10.0231 27.9999 14.5667 27.4233 16.7578C27.1004 17.9572 26.1547 18.9028 24.9554 19.2257C22.7643 19.8023 13.9999 19.8023 13.9999 19.8023C13.9999 19.8023 5.25863 19.8023 3.04447 19.2026C1.84513 18.8797 0.899502 17.9341 0.576604 16.7348C0 14.5667 0 10 0 10C0 10 0 5.45638 0.576604 3.26529C0.899502 2.06595 1.8682 1.09726 3.04447 0.774358C5.23556 0.197754 13.9999 0.197754 13.9999 0.197754C13.9999 0.197754 22.7643 0.197754 24.9554 0.797422ZM11.209 14.1986V5.80322L18.4973 10.0009L11.209 14.1986Z",
    fill: "#C4CBD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_258_585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 19.6045,
    fill: "white",
    transform: "translate(0 0.197754)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.682b7afbeb818d5057a143bc6def69ea.svg";
export { ForwardRef as ReactComponent };